export function getTagBotUserId(context: ResolverContext) {
  throw new Error('getTagBotUserId called on the client!');
}
